import { render, staticRenderFns } from "./DonutChart33.vue?vue&type=template&id=730a4182&scoped=true"
import script from "./DonutChart33.vue?vue&type=script&lang=js"
export * from "./DonutChart33.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730a4182",
  null
  
)

export default component.exports